export default __webpack_public_path__ + "static/media/section05.2c06b35d.jpg";